exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._21IDX{cursor:pointer}span._17Bkt,span._21IDX{font-size:16px;margin:0 8px}._1HaOx{color:#777;font-style:italic}._2AR9C{background:#f3d8d8;color:#8b0000}._3AjOt{background:#f9fad2}._3y2hy{background:#d2e7fa}._29R0p{padding:0!important}._2bsGM{padding:7px;line-height:24px}._1vwHP{padding:7px 3px;line-height:30px}._13e-S div{overflow-x:hidden!important}._13e-S div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_21IDX",
	"info": "_17Bkt",
	"sinSnapshot": "_1HaOx",
	"facturaCancelada": "_2AR9C",
	"conCambios": "_3AjOt",
	"conActualizaciones": "_3y2hy",
	"tdClear": "_29R0p",
	"field": "_2bsGM",
	"fieldAsignacion": "_1vwHP",
	"hidden": "_13e-S"
};